module.exports = __webpack_public_path__ + "img/8.9bd415a8.png";